/** Service type: はり・きゅう (acupuncture/moxibustion) */
export const SERVICE_TYPE_A2 = 'A2';

/** Service type: マッサージ (massage) */
export const SERVICE_TYPE_R2 = 'R2';

/** Service type: 両方 (both A2 and R2) */
export const SERVICE_TYPE_BOTH = 'BOTH';

export const SERVICE_TYPE_LABELS: Record<string, string> = {
  [SERVICE_TYPE_A2]: 'はり・きゅう',
  [SERVICE_TYPE_R2]: 'マッサージ',
  [SERVICE_TYPE_BOTH]: 'はり・きゅう、マッサージ',
};

/** Practitioner label: A2 = はり・きゅう師, R2 = マッサージ師. Compose with suffixes (e.g. `${MASSAGER_LABEL_A2}名`) where needed. */
export const MASSAGER_LABEL_A2 = 'はり・きゅう師';
export const MASSAGER_LABEL_R2 = 'マッサージ師';

/**
 * Get display label for service_type value (e.g. for table column サービス).
 */
export function getServiceTypeLabel(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  const st = value.toUpperCase();
  return SERVICE_TYPE_LABELS[st] ?? value;
}

/**
 * Get short display label using service code only (A2 / R2 / A2、R2).
 * Used by admin informations list column 表示サービス.
 */
export function getServiceTypeShortLabel(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  const st = value.toUpperCase();
  if (st === SERVICE_TYPE_BOTH) return `${SERVICE_TYPE_A2}、${SERVICE_TYPE_R2}`;
  if (st === SERVICE_TYPE_A2) return SERVICE_TYPE_A2;
  if (st === SERVICE_TYPE_R2) return SERVICE_TYPE_R2;
  return value;
}

/**
 * Resolve a usable service type from a possibly-undefined theme value.
 * Falls back to localStorage, then to A2 — mirrors RA2's session('service_type', …) default.
 */
export function resolveServiceType(themed: string | undefined): string {
  if (themed === SERVICE_TYPE_A2 || themed === SERVICE_TYPE_R2) return themed;
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('service_type') || SERVICE_TYPE_A2;
  }
  return SERVICE_TYPE_A2;
}
